// =============================================================================
// PotDisplay.tsx — Shows the current pot amount on the table
// Project: Texas Hold'em Social Casino
// =============================================================================

import React from 'react'

interface PotDisplayProps {
  amount: number
}

export default function PotDisplay({ amount }: PotDisplayProps): React.ReactElement | null {
  if (amount <= 0) return null

  return (
    <div className="pot-display">
      <div className="pot-label">Pot</div>
      <div>{amount.toLocaleString()}</div>
    </div>
  )
}
